import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, watch } from 'vue';
import { removeStore, setStore } from '@/util/store.js';
import { getLabelList } from '@/api/home';
export default {
  __name: 'index',
  props: {
    visibleNote: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:visibleNote', 'addNote'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    var labelList = ref([]);
    var originInfo = ref({
      type: 0,
      dataId: '',
      dataTitle: ''
    });
    var closeDialog = function closeDialog() {
      emit('update:visibleNote', false);
    };
    var handleUpdate = function handleUpdate(data) {
      emit('addNote');
      closeDialog();
    };
    watch(function () {
      return props.visibleNote;
    }, /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(val) {
        var query, _yield$getLabelList, data, _labelList;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!val) {
                _context.n = 2;
                break;
              }
              query = {
                queryKey: ''
              };
              _context.n = 1;
              return getLabelList(query);
            case 1:
              _yield$getLabelList = _context.v;
              data = _yield$getLabelList.data;
              // console.log(data,71)
              _labelList = data.data.map(function (item) {
                item.labelId = item.id;
                return item;
              });
              _labelList.value = _labelList;
              setStore({
                name: 'zxhj_label_list',
                content: _labelList
              });
              _context.n = 3;
              break;
            case 2:
              labelList.value = [];
              removeStore({
                name: 'zxhj_label_list'
              });
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), {
      immediate: true
    });
    return function (_ctx, _cache) {
      var _component_hxhy_note_editor = _resolveComponent("hxhy-note-editor");
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createBlock(_component_t_dialog, {
        visible: __props.visibleNote,
        width: "720",
        footer: false,
        destroyOnClose: true,
        onClose: closeDialog,
        class: "note-dialog"
      }, {
        header: _withCtx(function () {
          return _toConsumableArray(_cache[0] || (_cache[0] = [_createElementVNode("div", null, "新增笔记", -1)]));
        }),
        default: _withCtx(function () {
          return [_createVNode(_component_hxhy_note_editor, {
            class: "hxhy-class",
            onUpdate: handleUpdate,
            editable: "",
            originInfo: originInfo.value,
            list: labelList.value,
            edit: "",
            autoFocus: "",
            "mind-map": "",
            placement: "top",
            "success-msg": false,
            showSubmitBtn: true
          }, null, 8, ["originInfo", "list"])];
        }),
        _: 1
      }, 8, ["visible"]);
    };
  }
};